import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserHistoryV1Response } from './get-user-history-v1-response';
import { getUserHistoryV1ResponseSchema } from './get-user-history-v1-response';

export interface IGetUserHistoryV1Request {
  cursor?: string;
}

export async function getUserHistoryV1Api(
  userId: string,
  params?: IGetUserHistoryV1Request,
): Promise<IValidatedResponse<IGetUserHistoryV1Response>> {
  return getRequest<IGetUserHistoryV1Response>({
    path: `/sys/users/v1/${userId}/history`,
    schema: getUserHistoryV1ResponseSchema,
    options: {
      params: params?.cursor ? { cursor: params.cursor } : undefined,
    },
  });
}
